<span class="lowercase" *ngIf="daysBeforeDelivery === 0">
  {{ 'common.timing.today' | translate }}
</span>

<span class="lowercase" *ngIf="daysBeforeDelivery > 0">
  {{ 'common.timing.inDays' | translate:{count: daysBeforeDelivery} }}
</span>

<span class="lowercase" *ngIf="daysBeforeDelivery < 0">
  {{ 'common.timing.expiredDaysAgo' | translate:{count: -1 * daysBeforeDelivery} }}
</span>
